import { useStorage } from './useStorage'
import { LocalStorageKey } from '../enums/LocalStorageKey'
import { useEffect } from 'react'
import ms from 'ms'
import { fetchCountry } from '../functions/fetchCountry'

interface StoredCountry {
  country: string
  ms: number
}

const minMs = Date.now() - ms('7d')

export function useCountry(): string | null {
  const [storedCountry, setStoredCountry] = useStorage<StoredCountry | null>(
    LocalStorageKey.Country,
    null,
  )
  const outdated = storedCountry ? storedCountry.ms < minMs : true

  useEffect(() => {
    if (outdated) {
      fetchCountry()
        .then((country) => (country ? { country, ms: Date.now() } : null))
        .then(setStoredCountry)
    }
  }, [outdated, setStoredCountry])

  return outdated ? null : storedCountry ? storedCountry.country : null
}
